import { render } from "./HelpAhsDDSD.vue?vue&type=template&id=0f5a6846&scoped=true"
import script from "./HelpAhsDDSD.vue?vue&type=script&lang=js"
export * from "./HelpAhsDDSD.vue?vue&type=script&lang=js"

import "./HelpAhsDDSD.vue?vue&type=style&index=0&id=0f5a6846&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f5a6846"]])

export default __exports__